import { callSNOWDataService } from 'src/utils/snowDataServiceWrapper';
import { SNOW_VALIDATION_SERVICE_ENDPOINT } from 'src/config';
import {
	ValidationDefinition,
	ValidationStatus,
	ValidationType,
} from './configureAttributeStep.types';

export interface ValidationMetadataSummary {
	validationId: string;
	validationName: string;
	validationType: ValidationType | string;
	validationDescription: string;
	validationStatus: ValidationStatus | string;
}

interface ValidationMetadataData {
	validationId: string;
	validationName: string;
	validationType: ValidationType | string;
	validationDescription: string;
	validationStatus: ValidationStatus | string;
	validationParameters?: ValidationDefinition['validationParameters'];
	validationTypeConfig?: ValidationConfigData;
	validationConfig?: ValidationConfigData;
}

interface ValidationConfigData {
	operationId?: string;
	successCriteria?: string[];
	failureCriteria?: string[];
	override?: number | null;
}

export const listValidationMetadata = async (
	validationStatus: ValidationStatus = ValidationStatus.ACTIVE
): Promise<ValidationMetadataSummary[]> => {
	const response = await callSNOWDataService({
		path: '/validations/metadata',
		method: 'GET',
		url: SNOW_VALIDATION_SERVICE_ENDPOINT,
		queryParams: { validationStatus },
		body: null,
	});

	return response?.validationMetadataList ?? [];
};

const toValidationDefinition = (data: ValidationMetadataData): ValidationDefinition => {
	const config = data.validationTypeConfig ?? data.validationConfig;

	return {
		validationId: data.validationId,
		validationName: data.validationName,
		validationType: data.validationType,
		validationDescription: data.validationDescription,
		validationStatus: data.validationStatus,
		validationParameters: data.validationParameters ?? [],
		validationOperationConfig: config
			? {
				operationId: config.operationId ?? '',
				successCriteria: config.successCriteria ?? [],
				failureCriteria: config.failureCriteria ?? [],
				override: config.override ?? undefined,
			}
			: undefined,
	};
};

export const getValidationMetadata = async (
	validationId: string,
	validationType: ValidationType
): Promise<ValidationDefinition> => {
	const response = await callSNOWDataService({
		path: `/validations/metadata/${encodeURIComponent(validationId)}`,
		method: 'GET',
		url: SNOW_VALIDATION_SERVICE_ENDPOINT,
		queryParams: { validationType },
		body: null,
	});

	return toValidationDefinition(response?.validationMetadata ?? response ?? {});
};